var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHelpdocs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.895 6.667H17c-.84 0-1.607.36-2.113.85l-4.582 4.42a3.146 3.146 0 00-.972 2.26v13.35c0 1.72 1.389 3.12 3.095 3.12h12.467c1.716 0 3.105-1.4 3.105-3.12V9.797c0-1.73-1.389-3.13-3.105-3.13zm-13.578 7.62c.022-.1-.048-.53.357-.9l4.572-4.41c.329-.332.74-.3.903-.31v3.75c0 1.03-.833 1.87-1.855 1.87h-3.977z",
    fill: "#FFC53D"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.23 1.333h-7.896c-.84 0-1.607.36-2.113.85L3.64 6.603a3.147 3.147 0 00-.972 2.26v13.35c0 1.72 1.389 3.12 3.095 3.12h12.467c1.716 0 3.105-1.4 3.105-3.12V4.463c0-1.73-1.389-3.13-3.105-3.13zM4.65 8.953c.023-.1-.047-.53.358-.9l4.572-4.41c.329-.331.74-.299.903-.31v3.75c0 1.03-.833 1.87-1.855 1.87H4.651z",
    fill: "#597EF7"
  })));
}

export default __webpack_public_path__ + "./fonts/helpdocs.4083960cf329f9e3b3bae8e26c632ff7.svg";
export { SvgHelpdocs as ReactComponent };